import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import SEO from '../components/SEO';
import { FaFilePdf, FaDownload, FaBullseye, FaListUl } from 'react-icons/fa';
import './KurikulumPage.css'; // Reusing CSS for consistent styling

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const KesiswaanPage = () => {
    const [content, setContent] = useState(null);

    useEffect(() => {
        const fetchContent = async () => {
            try {
                // Fetch data from 'unitKerja' collection, document 'kesiswaan'
                const docRef = doc(db, 'unitKerja', 'kesiswaan');
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setContent(docSnap.data());
                }
            } catch (err) {
                console.error("Error fetching kesiswaan data:", err);
            }
        };

        fetchContent();
    }, []);

    // Gabungkan data programs dan documents dari DB jika ada, atau gunakan array kosong
    const programs = content?.programs || [];
    const documents = content?.documents || [];

    return (
        <>
            <SEO
                title="Waka Kesiswaan - SMK Pariwisata Sumbangsih"
                description="Informasi mengenai kegiatan kesiswaan, tata tertib, OSIS, dan ekstrakurikuler di SMK Pariwisata Sumbangsih."
            />

            <div className="kurikulum-page"> {/* Using same class for consistent styling */}
                {/* Hero Section */}
                <header className="kurikulum-header" style={{ backgroundImage: `url(${content?.imageUrl || 'https://images.unsplash.com/photo-1577896334502-8a25ae007559?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80'})` }}>
                    <div className="kurikulum-header-overlay">
                        <h1>Waka Kesiswaan</h1>
                        <div className="kurikulum-breadcrumb">Beranda / Unit Kerja / Kesiswaan</div>
                    </div>
                </header>

                <div className="container">
                    {/* Profile Section */}
                    <section className="kurikulum-section">
                        <div className="profile-card">
                            <div className="profile-image-container">
                                {/* Placeholder Image for Waka or DB Image */}
                                <img
                                    src={content?.wakaImageUrl || "https://ui-avatars.com/api/?name=Waka+Kesiswaan&background=random&size=256"}
                                    alt="Waka Kesiswaan"
                                    className="profile-image"
                                />
                            </div>
                            <div className="profile-content">
                                <h3>{content?.wakaName || "Nama Waka Kesiswaan, S.Pd."}</h3>
                                <div className="profile-role">{content?.wakaRole || "Wakil Kepala Sekolah Bidang Kesiswaan"}</div>
                                <div className="profile-quote">
                                    "{content?.wakaQuote ||
                                        "Karakter adalah fondasi kesuksesan. Melalui kedisiplinan dan kegiatan positif, kami membentuk pribadi siswa yang tangguh, bertanggung jawab, dan siap bersaing di dunia profesional."}"
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Visi Misi Section */}
                    <section className="kurikulum-section">
                        <div className="section-title">
                            <h2>Visi & Misi Kesiswaan</h2>
                            <p>Membentuk karakter dan kepribadian siswa yang unggul</p>
                        </div>

                        <div className="vm-grid">
                            <div className="vm-card">
                                <h3><FaBullseye /> Visi</h3>
                                <p>
                                    {content?.visi || "Terwujudnya peserta didik yang beriman, bertaqwa, berdisiplin tinggi, dan memiliki daya saing global dalam bidang pariwisata."}
                                </p>
                            </div>
                            <div className="vm-card">
                                <h3><FaListUl /> Misi</h3>
                                <ul className="vm-list">
                                    {(content?.misi && content.misi.length > 0 ? content.misi : [
                                        "Menanamkan nilai-nilai karakter dan budi pekerti luhur.",
                                        "Meningkatkan kedisiplinan dan ketertiban siswa.",
                                        "Mengembangkan potensi siswa melalui kegiatan ekstrakurikuler.",
                                        "Menciptakan lingkungan sekolah yang kondusif dan kekeluargaan."
                                    ]).map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </section>

                    {/* Program Kesiswaan Section with Swiper */}
                    <section className="kurikulum-section">
                        <div className="section-title">
                            <h2>Program Kesiswaan</h2>
                            <p>Kegiatan pengembangan karakter dan bakat siswa</p>
                        </div>

                        <div className="programs-slider-container">
                            {programs.length > 0 ? (
                                <Swiper
                                    modules={[Navigation, Pagination, Autoplay]}
                                    spaceBetween={30}
                                    slidesPerView={1}
                                    navigation
                                    pagination={{ clickable: true }}
                                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                                    breakpoints={{
                                        640: {
                                            slidesPerView: 1,
                                        },
                                        768: {
                                            slidesPerView: 2,
                                        },
                                        1024: {
                                            slidesPerView: 3,
                                        },
                                    }}
                                    className="programs-swiper"
                                >
                                    {programs.map((program, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="program-card">
                                                <div className="program-card-image">
                                                    {program.image ? (
                                                        <img src={program.image} alt={program.title} />
                                                    ) : (
                                                        <div className="program-placeholder-image">SMK PS</div>
                                                    )}
                                                </div>
                                                <div className="program-card-content">
                                                    <h3>{program.title}</h3>
                                                    <p>{program.description}</p>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            ) : (
                                <div className="text-center">Belum ada program kesiswaan yang ditambahkan.</div>
                            )}
                        </div>
                    </section>
                </div>

                {/* Download Center Section */}
                <section className="kurikulum-section download-section">
                    <div className="container">
                        <div className="section-title">
                            <h2>Dokumen Kesiswaan</h2>
                            <p>Unduh Tata Tertib dan Formulir Kesiswaan</p>
                        </div>

                        <div className="documents-grid">
                            {documents.length > 0 ? documents.map((doc, index) => (
                                <div key={index} className="doc-card">
                                    <div className="doc-icon"><FaFilePdf /></div>
                                    <div className="doc-info">
                                        <h4>{doc.title}</h4>
                                        <div className="doc-meta">{doc.date} • {doc.size}</div>
                                    </div>
                                    <a href={doc.url} target="_blank" rel="noopener noreferrer" className="doc-download-btn" title="Download"><FaDownload /></a>
                                </div>
                            )) : (
                                <div className="text-center" style={{ gridColumn: '1/-1' }}>Belum ada dokumen yang tersedia untuk diunduh.</div>
                            )}
                        </div>
                    </div>
                </section>

            </div>
        </>
    );
};

export default KesiswaanPage;
